import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';

const host = window.location.host;
if (
  host.includes('napdev.ru') ||
  host.includes('napishem.ru') ||
  host.includes('napishem.site') ||
  host.includes('helpman24.ru')
) {
  document
    .getElementsByTagName('head')[0]
    .insertAdjacentHTML(
      'beforeend',
      "<link rel='stylesheet' href='https://cdn.jsdelivr.net/npm/katex@0.15.1/dist/katex.min.css' />",
    );

  ReactDOM.render(<App />, document.getElementById('calc_areacircle'));
}
